// 1. Based on https://webpack.js.org/guides/dependency-management/#requirecontext
// The regex passed to require.context must be a literal and cannot be a constructor

// 2. Filtering based on an extension does not work, instead we need to blacklist
// see: https://github.com/reactjs/react-rails/issues/758#issuecomment-578309520
export const reactContext = require.context(
  '../react',
  true,
  // a blacklisting regex that positively identifies what i want to keep
  // i shouldn't have to do this but https://github.com/reactjs/react-rails/issues/758#issuecomment-578309520
  // forces me to
  // use https://regex101.com/r/CkTCyq/1 to update and test the regex
  /^(?!(.+__tests__.+|.+\.tests?\..+|.+\/tests?\/.+|.+\.md|\.gitkeep|.DS_store)$).+$/
);

// !NOTE: combining the two regexps into a shared variable has unintended consequences
export const stimulusContext = require.context(
  '../controllers',
  true,
  // Allows us to put __tests__ in the same folder as teh context
  // use https://regex101.com/r/CkTCyq/1 to update and test the regex
  /^(?!(.+__tests__.+|.+\.tests?\..+|.+\/tests?\/.+|.+\.md|\.gitkeep|.DS_store)$).+$/
);

export default { reactContext, stimulusContext };
